export { RoleGuard } from './lib/role.guard';
export * from './lib/shared-data-access-role-guard.module';
